import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import { fetchSignupFormResponses, updateSignupFormResponses } from "./thunk";

export interface SignupFormResponsesState {
  signupFormResponses: { [key: string]: { value: string } };
  error: string | null;
  hasPersonalInfoChanged: boolean;
  status: "idle" | "fetching" | "saving";
}

const initialState: SignupFormResponsesState = {
  signupFormResponses: {},
  error: null,
  status: "idle",
  hasPersonalInfoChanged: false
};

export const signupFormResponsesSlice = createSlice({
  name: "signupFormResponses",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setHasPersonalInfoChanged: (state, action) => {
      state.hasPersonalInfoChanged = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[signupFormResponsesSlice.name]
        };
      })
      .addCase(fetchSignupFormResponses.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchSignupFormResponses.fulfilled, (state, action) => {
        state.status = "idle";
        state.signupFormResponses = action.payload;
      })
      .addCase(fetchSignupFormResponses.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      })
      .addCase(updateSignupFormResponses.pending, (state) => {
        state.status = "saving";
        state.hasPersonalInfoChanged = false;
      })
      .addCase(updateSignupFormResponses.fulfilled, (state) => {
        state.status = "idle";
        state.hasPersonalInfoChanged = true;
      })
      .addCase(updateSignupFormResponses.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
        state.hasPersonalInfoChanged = false;
      });
  }
});

export const { setError, setHasPersonalInfoChanged } =
  signupFormResponsesSlice.actions;
